import { render } from "./DonationReceiptOverlay.vue?vue&type=template&id=e2498320"
import script from "./DonationReceiptOverlay.vue?vue&type=script&lang=js"
export * from "./DonationReceiptOverlay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__